/* eslint-disable @typescript-eslint/no-unused-vars */
import { MocksHelper } from './MocksHelper';
import { SaldoMockProvider } from './SaldoMockProvider';

const saldoProvider = new SaldoMockProvider();
const SaldoMockService = {
  retrieveSaldo: (input: object) => {
    const data = saldoProvider.getSaldoResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
};
export default SaldoMockService;
